<template>
  <v-app>
    <dashboard-idc-login />
  </v-app>
</template>

<script>
  export default {
    name: 'DashboardLogin',

    components: {
      DashboardIdcLogin: () => import('./components/idc/Login'),
    },

    data: () => ({
      expandOnHover: false,
    }),
  }
</script>
